import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-espresso" data-id="element-91">
      {/* Background Image with Parallax effect simulation */}
      <motion.div initial={{
      scale: 1.1
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute inset-0 z-0" data-id="element-92">
        <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop" alt="Carpintería Arquitectónica Premium" className="w-full h-full object-cover object-center" data-id="element-93" />
        <div className="absolute inset-0 bg-espresso/70 mix-blend-multiply" data-id="element-94"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-espresso/50 via-transparent to-espresso/90" data-id="element-95"></div>
      </motion.div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center mt-16" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-97">
          <span className="inline-block py-1 px-3 border border-gold/50 text-gold text-xs font-semibold tracking-widest uppercase mb-6 rounded-sm" data-id="element-98">
            Diseño & Manufactura
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-bone leading-tight mb-6" data-id="element-99">
          Carpintería Arquitectónica de{' '}
          <span className="text-gold italic" data-id="element-100">Alto Impacto</span> con Cobertura
          Nacional.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-bone/80 max-w-3xl mx-auto mb-10 font-light leading-relaxed" data-id="element-101">
          Fabricación industrial y diseño de autor para proyectos residenciales
          y grandes constructoras en toda Colombia. Transformamos la madera en
          el activo más valioso de su obra.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-102">
          <a href="#contacto" className="inline-block bg-gold hover:bg-gold-light text-espresso font-semibold px-8 py-4 text-lg transition-all duration-300 transform hover:-translate-y-1 rounded-sm shadow-[0_10px_40px_-10px_rgba(212,175,55,0.4)]" data-id="element-103">
            Iniciar Consultoría Técnica
          </a>
        </motion.div>
      </div>
    </section>;
}